<template>
  <div
    v-if="flipcard"
    class="pop-flipcard-component"
  >
    <div :class="['flipcard', {'back-visible': displayedSide === 'back'}]">
      <div
        v-if="displayedSide === 'front'"
        class="front"
      >
        <button
          class="flipper"
          @click="flipTo('back')"
        >
          <span
            v-if="!show"
            class="empty-value"
          >--</span>
          <span
            v-else
            class="value"
          >{{ valueDisplay }}</span>
          <span class="title">{{ title }}</span>
          <icon
            v-if="locked"
            name="lock"
            class="lock-icon"
          />
          <icon
            v-else
            name="mastery-arrow-right"
            class="flip-btn"
            variant="white"
          />
        </button>
      </div>
      <div
        v-if="displayedSide === 'back'"
        class="back"
      >
        <button
          class="flipper"
          @click="flipTo('front')"
        >
          <span
            v-if="!show"
            class="empty-value"
          >--</span>
          <span
            v-else
            class="value"
          >{{ valueDisplay }} – </span>
          <span class="title">{{ title }}</span>
          <span class="description">
            {{ description }}
          </span>
          <icon
            v-if="locked"
            name="lock"
            class="lock-icon"
          />
          <icon
            v-else
            name="mastery-arrow-right"
            class="flip-btn"
            variant="white"
          />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/singletons/icon';

export default {
  components: { Icon },
  props: {
    flipcard: {
      type: Object,
    },
    locked: {
      type: Boolean,
      default: true,
    },
    showResults: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      displayedSide: 'front',
    };
  },
  computed: {
    description() {
      return this.flipcard.description(this.flipcard.value, this.flipcard.secondaryValue);
    },
    show() {
      return !this.locked && this.showResults;
    },
    title() {
      return this.flipcard.title(this.flipcard.value);
    },
    valueDisplay() {
      if (this.flipcard.valueType === 'percentage') {
        return `${this.flipcard.value}%`;
      } else {
        return this.flipcard.value;
      }
    },
  },
  methods: {
    flipTo(side) {
      if (this.locked) {
        this.$store.dispatch('ui/toggleUpsellModal', { show: true, feature: 'Possibility of Passing' });
      } else {
        this.displayedSide = side;
        if (side = 'back') {
          this.$analytics.events.viewedScoreFactor(this.title);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pop-flipcard-component {
  display: inline-block;
  height: rem-calc(117);
  width: rem-calc(202);
  margin-bottom: rem-calc(15);
  perspective: 500px;
  border-radius: 4px;

  &:nth-child(1),
  &:nth-child(3) {
    margin-right: rem-calc(16);
  }

  &:nth-child(3),
  &:nth-child(4) {
    margin-bottom: 0;
  }

  .flipcard {
    border-radius: 4px;
    box-shadow: 0 2px 6px 0 rgba(0,0,0,0.1);
    display: block;
    height: 100%;
    box-sizing: border-box;
    font-size: rem-calc(12);
    padding: rem-calc(12);
    transition: transform 0.5s;
    transform-style: preserve-3d;
    position: relative;

    &.back-visible {
      transform: rotateY(180deg);
    }

    .front,
    .back {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      box-sizing: border-box;
      border-radius: 4px;

      .flipper {
        width: 100%;
        height: 100%;
        background: transparent;
        border: none;
        padding: rem-calc(16);
        text-align: left;

        > * {
          pointer-events: none;
        }
      }
    }

    .front {
      .empty-value {
        color: #bef7ff;
        font-weight: $bold;
        font-size: rem-calc(48);
        display: block;
        line-height: 1;
      }

      .value {
        @include charter-black;
        font-size: rem-calc(24);
        display: block;
      }

      .value + .title {
        margin-top: 4px;
      }

      .title {
        display: block;
      }
    }

    .back {
      backface-visibility: hidden;
      transform: rotateY(180deg);

      .empty-value {
        color: #bef7ff;
        font-weight: $bold;
        font-size: rem-calc(36);
        position: absolute;
        line-height: 0;
        top: 28px;
      }

      .empty-value + .title {
        display: inline-block;
        margin-left: rem-calc(32);
      }

      .value {
        @include charter-font;
        font-size: rem-calc(14);
      }

      .title {
        font-weight: $bold;
      }

      .description {
        display: block;
        margin-top: rem-calc(12);
        line-height: 1.33;
      }
    }

    .flip-btn,
    .lock-icon {
      position: absolute;
      top: 95px;
      right: 8px;
      padding: rem-calc(3);
      width: rem-calc(9);
      height: rem-calc(9);
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .flip-btn {
      border-radius: 100%;
      background-color: #00dbfb;
    }
  }
}
</style>
